import { STATUS_LABELS } from "@/lib/api";

export const CAR_GROUPS = [
  { key: "available", label: "Disponibile" },
  { key: "transport", label: "În transport" },
  { key: "sold", label: "Vândute" },
  { key: "all", label: "Toate" },
];

export function carGroup(status) {
  if (status === "vanduta") return "sold";
  if (status === "in_transport") return "transport";
  return "available";
}

const GROUP_STYLE = {
  available: "bg-emerald-50 text-emerald-700 border-emerald-200",
  transport: "bg-blue-50 text-blue-700 border-blue-200",
  sold: "bg-slate-100 text-slate-500 border-slate-200",
};

export function CarAvailabilityBadge({ status, testid }) {
  const style = status === "rezervata" ? "bg-amber-50 text-amber-700 border-amber-200" : GROUP_STYLE[carGroup(status)];
  return (
    <span data-testid={testid} className={`inline-flex items-center text-[10px] font-semibold uppercase tracking-wider px-2 py-0.5 rounded-full border ${style}`}>
      {STATUS_LABELS[status] || status}
    </span>
  );
}
